import script from "./customer-estimates.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-estimates.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__